import React from "react";
import { pointsToPath } from "../../lib/boardConstants";
import { cn } from "../../lib/utils";

export function BoardStroke({ element, selected, onSelect, interactive = true }) {
  const path = pointsToPath(element.points);
  if (!path) return null;

  return (
    <path
      d={path}
      fill="none"
      stroke={element.strokeColor || "#001EFF"}
      strokeWidth={element.strokeWidth || 3}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn(selected && "drop-shadow-[0_0_4px_rgba(0,30,255,0.45)]")}
      style={{
        pointerEvents: interactive ? "stroke" : "none",
        cursor: interactive ? "pointer" : "default",
      }}
      onPointerDown={
        interactive
          ? (event) => {
              event.stopPropagation();
              onSelect(element.id);
            }
          : undefined
      }
      data-testid={`board-stroke-${element.id}`}
    />
  );
}
